import * as React from "react";

import { Input } from "./ui/input";
import { Search } from "lucide-react";
import { cn } from "@/lib/utils";

const SearchInput = React.forwardRef<
  HTMLInputElement,
  React.InputHTMLAttributes<HTMLInputElement>
>(({ className, ...props }, ref) => {
  return (
    <div className="relative">
      <Search className="absolute top-3 left-3 w-4 h-4" />
      <Input
        {...props}
        className={cn("pl-8", className)}
        ref={ref}
        type="search"
      />
    </div>
  );
});

SearchInput.displayName = "SearchInput";

export default SearchInput;
